import TerminationOption from "../../../models/contract/TerminationOption";
import ExtensionOption from "../../../models/contract/ExtensionOption";
import BuyoutOption from "../../../models/contract/BuyoutOption";
import Devaluations from "./Devaluations";
import Expenses from "./Expenses";

export default class AssetComponent {
  constructor(
    idInDB,
    assetId,
    assetExternalId,
    name,
    externalId,
    isAmortizable,
    liquidationValue,
    unitOfMeasureCode,
    quantity,
    startDate,
    endDate,
    endDateInitial,
    endDateCommentary,
    extension,
    termination,
    buyout,
    isBuyout,
    lessorComponentShares,
    devaluations,
    expenses,
    isPermanent) {

    this.idInDB = idInDB;
    this.assetId = assetId;
    this.assetExternalId = assetExternalId;
    this.name = name;
    this.externalId = externalId; // can be null
    this.isAmortizable = isAmortizable; // can be null
    this.liquidationValue = liquidationValue; // can be null
    this.unitOfMeasureCode = unitOfMeasureCode; // can be null
    this.quantity = quantity; // can be null
    this.startDate = startDate; // can be null, string date wihtout time format
    this.endDate = endDate; // can be null, string date wihtout time format
    this.endDateInitial = endDateInitial; // can be null, string date wihtout time format
    this.endDateCommentary = endDateCommentary; // can be null
    this.extension = extension;
    this.termination = termination;
    this.buyout = buyout;
    this.isBuyout = isBuyout; // can be null
    this.lessorComponentShares = lessorComponentShares;
    this.devaluations = devaluations;
    this.expenses = expenses;
    this.isPermanent = isPermanent; //bool
  }

  static createFromData(data) {
    if (data == null) throw new Error("Cannot create AssetComponent from data if data is null.");

    const lessorComponentShares = [];
    for (let i = 0; i < data.lessorComponentShares.length; i++) {
      const element = data.lessorComponentShares[i];
      lessorComponentShares.push(element);
    }

    let devaluations = [];
    for (let i = 0; i < data.devaluations.length; i++) {
      const element = data.devaluations[i];
      devaluations.push(Devaluations.createFromData(element));
    }

    let expenses = [];
    for (let i = 0; i < data.expenses.length; i++) {
      const element = data.expenses[i];
      expenses.push(Expenses.createFromData(element));
    }

    let termination = null;
    if (data.termination !== null) {
      termination = TerminationOption.createFromData(data.termination);
    }

    let extension = null;
    if (data.extension !== null) {
      extension = ExtensionOption.createFromData(data.extension);
    }

    let buyout = null;
    if (data.buyout !== null) {
      buyout = BuyoutOption.createFromData(data.buyout);
    }

    return new AssetComponent(
      data.idInDB,
      data.assetId,
      data.assetExternalId,
      data.name,
      data.externalId,
      data.isAmortizable,
      data.liquidationValue,
      data.unitOfMeasureCode,
      data.quantity,
      data.startDate,
      data.endDate,
      data.endDateInitial,
      data.endDateCommentary,
      extension,
      termination,
      buyout,
      data.isBuyout,
      lessorComponentShares,
      devaluations,
      expenses,
      data.isPermanent
    );
  }

  static createNew() {
    const uuidv4 = require('uuid/v4');

    return new AssetComponent(
      uuidv4(), // idInDB
      null,
      null,
      null,
      null,
      true,
      null,
      null,
      null, // quantity
      null, // start date
      null, // end date
      null,
      null,
      null,
      null,
      null,
      false,
      [],
      [],
      [],
      false); //isPermanent
  }
}
